import React, { useContext, useEffect, useState } from "react";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar";
import blogFetch from "../../axios/config";
import { Container, Row } from "react-bootstrap";
import { ValidacaoLogoComponent } from "./components/ValidacaoLogoComponent";


export const ValidacaoLogo = () => {

  return (
    <>
      <Navbar />
      <Sidebar />

      <Container className="app_body" fluid>
        <Row>
            <ValidacaoLogoComponent/>
        </Row>
      </Container>
    </>
  )
}